'use client';

import dynamic from 'next/dynamic';
import SectionTransition from '@/components/home/section-transition';
import { SectionSkeleton } from '@/components/home/section-skeleton';

const TestimonialsCarousel = dynamic(() => import('@/components/home/testimonials-carousel'), {
  loading: () => <SectionSkeleton />,
  ssr: false,
});

const WistaGroupSection = dynamic(() => import('@/components/home/wista-group-section'), {
  loading: () => <SectionSkeleton />,
  ssr: false,
});

// Reserved heights match the rendered heights of each ssr:false section
// so the page doesn't jump when the lazy chunk hydrates. Bump these if the
// underlying component gets taller.
const TESTIMONIALS_MIN_HEIGHT = 'min-h-[800px]';
const WISTA_GROUP_MIN_HEIGHT = 'min-h-[700px]';

export default function HomeSectionsBelowFold() {
  return (
    <>
      <SectionTransition variant="horizontal">
        <div className={TESTIMONIALS_MIN_HEIGHT}>
          <TestimonialsCarousel />
        </div>
      </SectionTransition>
      <SectionTransition variant="circular">
        <div className={WISTA_GROUP_MIN_HEIGHT}>
          <WistaGroupSection />
        </div>
      </SectionTransition>
    </>
  );
}
